import { ExtendableImage } from '@design-system/extendable-image';
import { Typography } from '@design-system/typography';
import React, { FC } from 'react';

import { PaymentProps } from './models';

const Payment: FC<PaymentProps> = ({
  paymentMethods,
  paymentMethodsLabel,
  paymentMethodsLabelUI,
  paymentDescriptionsWithImage,
}) => (
  <div className="shopping-cart__payment">
    <div className="payment-methods">
      {paymentMethodsLabel ? (
        <Typography
          {...paymentMethodsLabelUI}
          content={paymentMethodsLabel}
          className="payment-methods__title"
        />
      ) : null}
      {paymentMethods.length ? (
        <div className="payment-methods__images-wrapper">
          {paymentMethods.map((paymentMethod, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <ExtendableImage key={index} {...paymentMethod} />
          ))}
        </div>
      ) : null}
    </div>
    {paymentDescriptionsWithImage?.map(
      ({ description, descriptionUI, image }, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <div className="payment-description" key={index}>
          <ExtendableImage {...image} />
          <Typography
            {...descriptionUI}
            content={description}
            className="payment-description__text"
          />
        </div>
      )
    )}
  </div>
);

export default Payment;
